import { Box, Paper, Stack } from '@mui/material';
import { useId, type ReactNode } from 'react';
import { ResultState } from './ResultState';
import { LoadingIndicator } from './LoadingIndicator';
import { visuallyHiddenStyles } from './visuallyHidden';

type FullPageMessageStateProps = {
  title: ReactNode;
  description?: ReactNode;
  loading?: boolean;
  action?: ReactNode;
  loadingOnly?: false;
};

type FullPageLoadingOnlyStateProps = {
  title?: never;
  description?: never;
  loading: true;
  action?: never;
  loadingOnly: true;
  loadingLabel: string;
};

export type FullPageStateProps = FullPageMessageStateProps | FullPageLoadingOnlyStateProps;

export function FullPageState(props: FullPageStateProps) {
  const titleId = useId();
  if (props.loadingOnly) {
    return (
      <Stack sx={{ minHeight: '100vh', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 3 }}>
        <LoadingIndicator label={props.loadingLabel} />
      </Stack>
    );
  }

  const { title, description, loading = false, action } = props;
  return (
    <Stack sx={{ minHeight: '100vh', placeItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 3 }}>
      <Box sx={{ width: 'min(420px, 100%)' }}>
        {loading ? <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}><Stack spacing={2} sx={{ alignItems: 'center' }}>
          <LoadingIndicator labelledBy={titleId} />
          <Box id={titleId} sx={visuallyHiddenStyles}>{title}</Box>
          {description != null && description !== '' ? <Box sx={visuallyHiddenStyles}>{description}</Box> : null}
          {action}
        </Stack></Paper> : <ResultState title={title} description={description} action={action} />}
      </Box>
    </Stack>
  );
}
